import { render, staticRenderFns } from "./text_extension.vue?vue&type=template&id=581bc4d2&scoped=true&"
import script from "./text_extension.vue?vue&type=script&lang=js&"
export * from "./text_extension.vue?vue&type=script&lang=js&"
import style0 from "./text_extension.vue?vue&type=style&index=0&id=581bc4d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581bc4d2",
  null
  
)

export default component.exports